export default {
    Video: 'VIDEO',
    Image: 'IMAGE',
};
